import { StreamTextUtils } from "./StreamTextUtils";

export class ConversationHistoryMessageMapper {
  constructor({ streamTextUtils } = {}) {
    this.streamTextUtils = streamTextUtils || new StreamTextUtils();
  }

  mapApiMessagesToChat(messages) {
    if (!Array.isArray(messages)) return [];
    return messages.map((m) => this._mapOne(m)).filter(Boolean);
  }

  _mapOne(m) {
    const role = typeof m?.role === "string" ? m.role.toLowerCase() : "";
    const timestamp =
      m?.timestamp || m?.created_at || m?.createdAt || m?.updated_at || null;
    if (role === "user") {
      return { sender: "user", text: String(m.content || ""), timestamp };
    }
    if (role === "assistant") {
      const contextArray = this._contextArrayFromAnnotations(m.annotations);
      return {
        sender: "bot",
        text: String(m.content || ""),
        timestamp,
        contextArray,
        isDone: true,
      };
    }
    return null;
  }

  _contextArrayFromAnnotations(annotations) {
    if (!Array.isArray(annotations)) return [];
    for (const ann of annotations) {
      if (ann?.type === "sources" && Array.isArray(ann?.data?.sources)) {
        return this.streamTextUtils.indexSourcesByContextId(ann.data.sources);
      }
    }
    return [];
  }
}
